/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The necessary data to register a new company
 */
export type CompanyRegistrationV2 = {
  features: {
    normal_working_time: boolean
    project_time: boolean
  }
  digitalization_options: {
    vacation: boolean
    absences: boolean
    employeefile: boolean
    company_analysis: boolean
    staff_planning: boolean
    datev: boolean
  }
  documentation_features: {
    photos: boolean
    sketches: boolean
    notes: boolean
    checklists: boolean
    projectfile: boolean
  }
  selected_industry: CompanyRegistrationV2.selected_industry
  selected_company_size: CompanyRegistrationV2.selected_company_size
  self_acclaimed_lead_source?: CompanyRegistrationV2.self_acclaimed_lead_source | null
  company_name: string
  first_name: string
  last_name: string
  phone?: string | null
  email: string
  app_check_token: string
}
export namespace CompanyRegistrationV2 {
  export enum selected_industry {
    SERVICES = 'services',
    CRAFT = 'craft',
    HEALTH = 'health',
    TRADING = 'trading',
    HOTEL = 'hotel',
    CARS = 'cars',
    OTHER = 'other',
  }
  export enum selected_company_size {
    _1_10 = '1-10',
    _11_50 = '11-50',
    _1_4 = '1-4',
    _5_10 = '5-10',
    _11_20 = '11-20',
    _21_50 = '21-50',
    _51_100 = '51-100',
    _100_ = '100+',
  }
  export enum self_acclaimed_lead_source {
    RECOMMEND = 'recommend',
    FACEBOOK = 'facebook',
    INSTAGRAM = 'instagram',
    INTERNET = 'internet',
    LINKEDIN = 'linkedin',
    COMPARISON = 'comparison',
    ARTICLE = 'article',
  }
}
